function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTodayIcon = function SvgTodayIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M1.278 12.064a.949.949 0 0 1 0-1.342l7.38-7.38L10 2l1.342 1.342 5.3 5.3 2.08 2.08a.949.949 0 0 1-1.342 1.342l-.738-.738v6.804H10.95v-2.847a.949.949 0 0 0-1.897 0v2.847H3.359V11.325l-.74.739a.949.949 0 0 1-1.341 0Zm13.467-2.636L10 4.684 5.256 9.427v6.806h1.898v-.95a2.846 2.846 0 1 1 5.693 0v.95h1.898V9.428Z",
    clipRule: "evenodd"
  }));
};
export default SvgTodayIcon;